import { Field } from "@progress/kendo-react-form";
import { FormRegion } from "../../../../components/formregion";
import { FormDropDownListById } from "../../../../forms/form-components";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const SelectDatasetStep = ({ onChangeDataset, onChange, ...props }) => {
  const { t } = useTranslation();
  const pageState = useSelector((state) => state.importSchedulePage);

  const lstOfDatasets = pageState.formValues.Datasets ?? [];

  return (
    <FormRegion>
      <div className="form-group form-group-1" style={{ marginBottom: 50 }}>
        <Field
          id="datasetId"
          name="datasetId"
          label={t("datasources.dataset")}
          component={FormDropDownListById}
          dataItemKey="Id"
          textField="Title"
          data={lstOfDatasets}
          onChange={(e) => onChangeDataset(e.value, onChange)}
        />
      </div>
    </FormRegion>
  );
};

export default SelectDatasetStep;
